import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
const names = ['Mariana', 'Julieta', 'Romina', 'Florencia', 'Agustina', 'Pablo', 'Martín', 'Diego', 'Nicolás', 'Valentina', 'Camila', 'Sofía', 'Lucas', 'Tomás', 'Facundo'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Stay for 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Then random intervals between 8-12 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * 4000 + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-160">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-gray-100 shadow-xl rounded-xl p-4 max-w-[300px] flex items-center gap-3" data-id="element-161">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-162">
            <ShoppingCart className="w-5 h-5 text-green-600" data-id="element-163" />
          </div>
          <div data-id="element-164">
            <p className="text-sm font-semibold text-gray-800" data-id="element-165">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-166">
              acaba de adquirir este libro
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};